import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { Image } from '@components/Image';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import SuccessImage from './assets/Success.png';
import { useHistory } from 'react-router-dom';

const WithdrawalSuccessScreen = () => {
  const classes = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down('md'));
  const history = useHistory();

  return (
    <div className={classes.root}>
      <Image
        src={SuccessImage}
        width={matches ? 64 : 80}
        height={matches ? 64 : 80}
        alt=""
        className="success-image"
      />
      <CustomizedTypography
        variant={matches ? 'h3' : 'h2'}
        color="textPrimary"
        gutterBottoms={matches ? 16 : 24}
        fontWeight="bold"
      >
        캐파 통합회원 탈퇴가 완료되었습니다.
      </CustomizedTypography>
      <CustomizedTypography
        variant={matches ? 'body1' : 'h4'}
        color="textPrimary"
        gutterBottoms={matches ? 40 : 48}
        align="center"
      >
        그동안 캐파 서비스를 아끼고 사랑해주셔서 감사합니다.
        <br />
        더욱 더 노력하고 발전하는 캐파가 되겠습니다.
      </CustomizedTypography>
      <CustomizedButton
        fullWidth={matches}
        variant="outlined"
        color="primary"
        size="large"
        onClick={() => history.push('/')}
      >
        캐파 메인으로 이동
      </CustomizedButton>
    </div>
  );
};

export default WithdrawalSuccessScreen;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '120px 0px',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '160px 16px'
    },
    '& .success-image': {
      marginBottom: 24
    }
  }
}));
